module.exports = __webpack_public_path__ + "assets/img/teacher (15).e16dd255.png";